import { action, computed, observable, makeAutoObservable } from 'mobx';
import { FormInputState } from 'src_common/common/mobx-utils/Form2/FormInputState';
import { OptionType } from 'src/AppState/ConfigState/types';
import { LanguagesState } from 'src/AppState/CmsState/LanguagesState/LanguagesState';

export class LanguageSelectState {
    @observable public language: FormInputState<string, string>;
    @observable public selectedLanguage: OptionType | null = null;

    public constructor(
        private languagesState: LanguagesState,
        private formLanguage: FormInputState<string, string>,
        private getAllSelectedLanguages: () => Array<OptionType>,
        private setSelectedLanguages: (newSelectedLanguages: Array<OptionType>) => void
    ) {
        this.language = FormInputState.new('');
        makeAutoObservable(this);
    }

    @computed public get allSelectedLanguages(): Array<OptionType> {
        return this.getAllSelectedLanguages();
    }

    @computed public get availableOptions(): Array<OptionType> {
        const availableLanguages = this.languagesState.getNonDefaultLanguagesList().filter((option) => {
            const languageExists = this.allSelectedLanguages.map(({ value }) => value).includes(option.value) === false;
            return languageExists;
        });

        return [...(this.selectedLanguage === null ? [] : [this.selectedLanguage]), ...availableLanguages];
    }

    @computed public get displayedLanguage(): string {
        return this.languagesState.getLanguageByValue(this.formLanguage.value)?.label ?? '';
    }

    @action public onChangeLanguage = (value: string): void => {
        const currentLanguage = this.language.value;

        this.language.setValue(value);
        this.formLanguage.setValue(value);

        const previousLanguage = this.allSelectedLanguages.find((item) => item.value === currentLanguage);
        const addedLanguage = this.languagesState.getOperatorLanguagesList().find((item) => item.value === value);

        if (previousLanguage !== undefined) {
            const index = this.allSelectedLanguages.indexOf(previousLanguage);
            this.allSelectedLanguages.splice(index, 1);
        }

        if (addedLanguage !== undefined) {
            this.selectedLanguage = addedLanguage;
            const addedLanguages: Array<OptionType> = [
                ...this.allSelectedLanguages,
                {
                    value: addedLanguage.value,
                    label: addedLanguage.label,
                },
            ];

            this.setSelectedLanguages(addedLanguages);
        }
    };
}
